<div class="col-sm-12 col-lg-12 p-0 mb-3x">
    <common-ui-card message="{{infoMessage}}" type="warning"></common-ui-card>
</div>
<h5 class="mb-3x">{{ 'COMMON_UI.ERIC_RESPONSE.TITLE' | translate }}</h5>
<div>
    <ul class="list-group d-flex" id="ericErrorList">
        <li *ngFor="let errorMsg of ericErrorMessages; let i=index" id="ericError{{i}}">
            <!--      TODO ERIC RESPONSE PROPOSAL. PLEASE DO NOT DELETE THE FOLLOWING LINES -->
            <!--                  <common-ui-card (selected)="messageSelected(errorMsg)" [message]="errorMsg.value" type="eric-error"></common-ui-card> -->
            <common-ui-card
                    (selected)="messageSelected(errorMsg)"
                    [message]="errorMsg"
                    type="eric-error">
            </common-ui-card>
        </li>
    </ul>
</div>
